import { useNavigate } from "react-router-dom";
import { Truck } from "react-feather";
import BuscaGrande from "@/components/project/BuscaGrande";
import Cabecalho from "@/components/project/Cabecalho";
import Rodape from "@/components/project/Rodape";
import { FaixaBeuni } from "@/components/project/Vitrine";
import garrafa from "@/assets/images/inicio-garrafa.jpg";

// Entrada do betracking, no mesmo visual do rastreio (Murilo, 20/10/2026):
// menu marrom com o convite pra beuni, a busca como o destaque da página, uma
// foto real de produto com um status de exemplo por cima (mostra o que é o
// betracking sem precisar explicar), a faixa "Para empresas" e o rodapé.
export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-[#EDE4DA]">
      <Cabecalho />

      <main className="flex-1">
        <section className="mx-auto grid max-w-7xl grid-cols-[minmax(0,1fr)] items-center gap-10 px-4 py-10 sm:px-6 sm:py-12 lg:grid-cols-[1.1fr_1fr] lg:gap-16 lg:py-20">
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wider text-[#C2410C]">Rastreamento de encomendas</p>
            <h1 className="mt-3 text-4xl font-bold leading-[1.05] tracking-tight text-[#3F2021] sm:text-6xl">
              Onde está a sua encomenda?
            </h1>
            <p className="mt-4 max-w-lg text-lg leading-relaxed text-[#6b5556]">
              Digite o código de rastreio que você recebeu por e-mail ou WhatsApp e acompanhe cada etapa até a entrega.
            </p>

            <div className="mt-8">
              <BuscaGrande onBuscar={(codigo) => navigate(`/track/${codigo}`)} autoFocus />
            </div>

            <p className="mt-5 flex items-center gap-2 text-sm text-[#6b5556]">
              <Truck size={16} className="shrink-0 text-[#C2410C]" />
              Correios, Jadlog e diversas outras transportadoras, num lugar só.
            </p>
          </div>

          {/* Foto real com um status de exemplo por cima. */}
          <div className="relative mx-auto mb-6 w-full max-w-md lg:mb-0 lg:max-w-none">
            <img src={garrafa} alt="Garrafa personalizada da beuni" className="aspect-square w-full rounded-[2rem] object-cover shadow-[0_20px_50px_rgba(63,32,33,0.18)]" />
            <div className="absolute -bottom-6 left-4 right-4 rounded-2xl bg-white p-4 shadow-[0_12px_32px_rgba(63,32,33,0.18)] sm:left-auto sm:right-[-1rem] sm:w-80 lg:-left-10 lg:right-auto" aria-hidden="true">
              <div className="flex items-center gap-2">
                <span className="relative flex size-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DC4405] opacity-60" />
                  <span className="relative inline-flex size-2 rounded-full bg-[#DC4405]" />
                </span>
                <span className="text-xs font-bold uppercase tracking-wide text-[#C2410C]">Saiu para entrega</span>
                <span className="ml-auto text-xs text-[#8a7778]">hoje, 08:12</span>
              </div>
              <p className="mt-1.5 font-bold text-[#3F2021]">Chega hoje no seu endereço</p>
              <div className="mt-3 grid grid-cols-4 gap-1.5">
                {[0, 1, 2, 3].map((i) => (
                  <span key={i} className={`h-1.5 rounded-full ${i < 3 ? "bg-[#DC4405]" : "bg-[#EADFD3]"}`} />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <FaixaBeuni />
      <Rodape />
    </div>
  );
}
